<template>
	<div class="container">
		<!--页面开始-->
		<div class="main_box">
			<div class="list_box">
				<div class="user_list">
					<div v-for="(value, index) in listData" class="list_el">
						<div class="one" @click="checked(value)">
							<img v-if="value.id == nowId" src="../../assets/img/icon_checked.png" />
							<img v-else src="../../assets/img/icon_nocheck.png" />
						</div>
						<div class="two" @click="checked(value)">{{ value.username }}</div>
						<div class="three" @click="checked(value)">{{ initCard(value) }}</div>
						<div class="four" @click="goEdit(value)">
							<img src="../../assets/img/icon_edit.png" />
						</div>
					</div>
				</div>
				<div v-if="isShow" class="btn_add">
					<img src="../../assets/img/icon_add.png" @click="goAdd" />
				</div>
			</div>
			<div class="btn_box">
				<div v-if="listData.length > 0" class="btn_tit">
					<van-checkbox
						v-model="isChecked"
						shape="square"
						icon-size="0.35rem"
						@click="xieyiChange"
					>
						我同意将填报的全部信息授权保义通平台使用，并承诺所有信息完全真实、准确、合法，如有虚报、隐瞒或其他违法情形，本人愿承担全部法律责任。
					</van-checkbox>
				</div>
				<van-button
					type="info"
					block
					@click="goSatrt"
					color="#4f56fe"
				>
					{{ btnText }}
				</van-button>
			</div>
		</div>
		<!--页面开始-->
	    <!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { xieyiCheck, xieyiSave } from "@/api/public";
import { otherList } from "@/api/other/index";
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		//
	},
	data() {
		return {
			listData: [],
			btnText: '',  //按钮文字
			nowId: null,  //当前选中id
			isShow: true,  //添加按钮
			isLoading: true,
			isChecked: false,  //复选框选中
		}
	},
	created(){
		let that = this;
		if(!localStorage.getItem('token')) {
			this.$router.push({path:'/login'});
		}
		if(that.$route.query.type == 1) {
			//检测
			that.btnText = '开始检测';
		}else if(that.$route.query.type == 2) {
			//拍照
			that.btnText = '开始拍照上传';
		}else {
			window.history.go(-1);
		}
		sessionStorage.clear();
		//获取成员列表
		otherList().then(res => {
			that.listData = res.data;
			if(that.listData.length >= 8) {
				that.isShow = false;
			}
			if(that.listData.length > 0) {
				//查询协议状态
				xieyiCheck().then(res => {
					if(res.is_checked == 1) {
						//未同意
						that.isChecked = false;
					}else if(res.is_checked == 2) {
						//同意
						that.isChecked = true;
					}
				});
			}
			that.isLoading = false;
		});
	},
	mounted() {
		//微信分享
		let that = this;
		that.$nextTick(() => {
			shareUrl(that);
		});
	},
	watch: {
		//
	},
	methods: {
		//协议点击
		xieyiChange() {
			let that = this;
			let num = null;
			if(that.isChecked) {
				num = 2;
			}else {
				num = 1;
			}
			//保存状态
			xieyiSave({is_checked: num}).then(res => {});
		},
		//初始化身份证号
		initCard(value) {
			let that = this;
			if(value.card_type == 2) {
				//军官证
				let str1 = value.card_number.slice(0, 3);
				let str2 = value.card_number.slice(-1);
				return str1 + '***********' + str2;
			}else {
				let str1 = value.card_number.slice(0, 3);
				let str2 = value.card_number.slice(-4);
				return str1 + '***********' + str2;
			}
		},
		//点击选中数据
		checked(value) {
			let that = this;
			if(value.id == that.nowId) {
				that.nowId = null;
			}else {
				that.nowId = value.id;
			}
		},
		//点击添加
		goAdd() {
			let that = this;
			that.$router.push({path: '/otheraddedit', query: {type: 1}});
		},
		//点击编辑
		goEdit(value) {
			let that = this;
			that.$router.push({path: '/otheraddedit', query: {type: 2, value: value.id}});
		},
		//开始检测
		goSatrt() {
			let that = this;
			if(that.nowId) {
				if(that.isChecked) {
					if(that.$route.query.type == 1) {
						//检测
						sessionStorage.setItem('otherId', that.nowId);
						//that.$router.replace({path:'/stepone'});
						//选择产品
						that.$router.push({path:'/productcheck', query: { type: 1 }});
					}else if(that.$route.query.type == 2) {
						//拍照
						sessionStorage.setItem('otherId', that.nowId);
						//that.$router.replace({path:'/upload'});
						//选择产品
						that.$router.push({path:'/productcheck', query: { type: 2 }});
					}
				}else {
					that.$toast('请阅读并勾选授权');
				}
			}else {
				that.$toast('请选择一位成员');
			}
		},
	},
	beforeDestroy() {
		//
	}
}
</script>
</script>

<style scoped>
/*loading*/
.loading{width:100%;height:100%;position:absolute;display:flex;justify-content:center;align-items:center;top:0;right:0;bottom:0;left:0;background:#ffffff;z-index:999;}

.list_box{
	padding-top: 0.4rem;
	padding-bottom: 6rem;
}
/*列表*/
.list_el{
	height: 1.4rem;
	display: flex;
	align-items: center;
	border-bottom: 1px solid #F7F7F7;
}
.list_el .one img, .list_el .four img{
	width: 0.32rem;
}
.list_el .one{
	width: 1.4rem;
	display: flex;
	align-items: center;
	justify-content: center;
}
.list_el .two{
	width: 1.8rem;
	color: #333333;
	font-size: 0.427rem;
	white-space:nowrap; 
	overflow:hidden; 
	text-overflow:ellipsis;
}
.list_el .three{
	flex: 1;
	padding-left: 0.5rem;
	position: relative;
	top: 1px;
	color: #999999;
	font-size: 0.427rem;
}
.list_el .four{
	width: 1.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
}

.btn_add{
	padding-top: 0.2rem;
	width: 80%;
	margin: 0 auto;
}
.btn_add img{
	width: 100%;
}

.van-button{
	height: 1.2rem;
}
.btn_box{
	position: fixed;
	/* argin-top: 4rem; */
	width: 100%;
	left: 0;
	padding: 1.2rem 1rem;
	bottom: 0;
	background-color: #ffffff;
}
>>> .btn_box .van-checkbox__label{
	margin-left: 4px;
	padding-bottom: 0.3rem;
	font-size: 0.32rem !important;
	color: #999999;
}
.btn_box .van-checkbox{
	align-items: baseline;
	/* display: inline-block;
	position: relative;
	top: 0.08rem;
	padding-right: 0.05rem; */
}
</style>
